import React from "react";
import { withTranslation } from "react-i18next";
import LoadingSpinner from "./LoadingSpinner";
import "./SubstituteSelector.scss";

/**
 * Reusable action button group component
 * @param {string} primaryLabel - Primary button label (defaults to "next")
 * @param {function} onPrimaryClick - Primary button click handler
 * @param {function} onCancel - Cancel button click handler
 * @param {boolean} isLoading - Loading state for primary button
 * @param {boolean} isDisabled - Disabled state for primary button
 * @param {string} primaryButtonKey - Translation key for primary button (defaults to "next")
 */
const ActionButtonGroup = ({
  primaryLabel,
  onPrimaryClick,
  onCancel,
  isLoading = false,
  isDisabled = false,
  primaryButtonKey = "next",
  t,
}) => {
  return (
    <div className="sss-btn-group">
      <button
        className={
          "button button-round button-shadow" +
          (isLoading ? " button-loading" : "")
        }
        onClick={onPrimaryClick}
        disabled={isDisabled || isLoading}
      >
        {primaryLabel || t(primaryButtonKey)}
        {isLoading && <LoadingSpinner inline />}
      </button>
      <button
        onClick={onCancel}
        className="button button-round button-border button-dark"
      >
        {t("cancel")}
      </button>
    </div>
  );
};

export default withTranslation()(ActionButtonGroup);

